export const collectiveOperationsTranslations = {
  bo_external: {
    collective_operations: {
      name: 'Opération collective |||| Opérations collectives',
      tabs: {
        draft: {
          label: 'Brouillons',
        },
        in_progress: {
          label: 'En cours',
        },
        history: {
          label: 'Historique',
        },
        migrated: {
          label: 'Opérations migrées',
        },
      },
      fields: {
        id: 'ID Opération',
        operation_type: 'Type',
        type: 'Type de campagne',
        date: 'Date',
        total_gross_amount: 'Montant brut',
        total_net_amount: 'Montant net',
        number_of_eligible_employees: 'Salariés éligibles',
        status: 'Statut',
        created_at: 'Créé le',
        updated_at: 'Mis à jour le',
      },
      types: {
        campaign: 'Campagne',
        matching_contribution: 'Abondement',
      },
      choices: {
        type: {
          matching_contribution: 'Abondement',
          ccb_withdrawal: 'Retrait CCB',
        },
      },
    },
  },
};
